import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import {
  AdminCardComponent, AppsCardComponent, ConfirmationDialogInputComponent, FooterComponent
  , GeneralSettingsComponent, HelpCardComponent, HtmlPaneComponent, MenuVerticalComponent
  , ModbarComponent, TopbarComponent, UserCardComponent, UserSettingsComponent, UserSettingsTabContainerComponent
  , QueryPanelComponent, QueryPanelFilterBoxComponent, CriteriaContainerComponent, CriteriaSummaryBox
  , CheckboxCriteriaComponent, DateRangeCriteriaComponent, NumericTextBoxCriteriaComponent, TreeViewCriteriaComponent
  , SharedDialogComponent, FileUploadDialogComponent
} from './components';
import { NullableBooleanClassDirective, SettingsDirective } from './directives';
import {
    HomePageComponent, LoginComponent, PageNoLicenseComponent, PageNotAuthorizedComponent, PageNotFoundComponent
} from './pages';
import {
    DatePreferencePipe, EmptyNumberFormatPipe, NumberFormatPipe, SafeHtmlPipe,
    SafeUrlPipe, UtcToLocalPipe
} from './pipes';
import {
    AppInsightsService,
    AuthorizationService,
    ConfirmationDialogHtmlPaneService, ConfirmationDialogInputService, ConfirmationDialogService,
  LoggingService, MonitoringService, NotificationDialogService, NotificationPopupService, UiWindowService, UserService
  , QueryPanelConnectorService, QueryPanelContentConnectorService
} from './services';

@NgModule({
  imports: [
    CommonModule
    , NgbDropdownModule
    , RouterModule
    , NgbModule
    , AdminCardComponent
    , AppsCardComponent
    , HelpCardComponent
    , FooterComponent
    , GeneralSettingsComponent
    , MenuVerticalComponent
    , ModbarComponent
    , ConfirmationDialogInputComponent
    , HtmlPaneComponent
    , TopbarComponent
    , UserCardComponent
    , UserSettingsComponent
    , UserSettingsTabContainerComponent
    , HomePageComponent
    , LoginComponent
    , SharedDialogComponent
    , FileUploadDialogComponent
    , CriteriaContainerComponent
    , CriteriaSummaryBox
    , CheckboxCriteriaComponent
    , DateRangeCriteriaComponent
    , NumericTextBoxCriteriaComponent
    , TreeViewCriteriaComponent
    , QueryPanelFilterBoxComponent
    , QueryPanelComponent
    , PageNoLicenseComponent
    , PageNotAuthorizedComponent
    , PageNotFoundComponent
    , NullableBooleanClassDirective
    , SettingsDirective
    , DatePreferencePipe
    , EmptyNumberFormatPipe
    , NumberFormatPipe
    , SafeHtmlPipe
    , SafeUrlPipe
    , UtcToLocalPipe
  ],
  exports: [
    AdminCardComponent
    , AppsCardComponent
    , HelpCardComponent
    , FooterComponent
    , GeneralSettingsComponent
    , MenuVerticalComponent
    , ModbarComponent
    , ConfirmationDialogInputComponent
    , TopbarComponent
    , UserCardComponent
    , UserSettingsComponent
    , UserSettingsTabContainerComponent
    , HomePageComponent
    , LoginComponent
    , PageNoLicenseComponent
    , PageNotAuthorizedComponent
    , PageNotFoundComponent
    , NullableBooleanClassDirective
    , SettingsDirective
    , DatePreferencePipe
    , EmptyNumberFormatPipe
    , NumberFormatPipe
    , SafeHtmlPipe
    , SafeUrlPipe
    , UtcToLocalPipe
  ],
  providers: [
    ConfirmationDialogService
    , ConfirmationDialogHtmlPaneService
    , ConfirmationDialogInputService
    , NotificationDialogService
    , NotificationPopupService
    , UserService
    , DatePreferencePipe
    , AppInsightsService
    , LoggingService
    , MonitoringService
    , AuthorizationService
    , UiWindowService
    , QueryPanelConnectorService
    , QueryPanelContentConnectorService
  ]
})
export class FwcoreModule { }
